import { PlaceActionType } from './place-action-type';
import { PlaceEntry } from '../../state';

export interface LoadPlaceSuccessAction {
  place: Partial<PlaceEntry['place']>;
  placeKey: string;
  type: PlaceActionType.LoadPlaceSuccess;
}

export const loadPlaceSuccess = (
  placeKey: string,
  place: Partial<PlaceEntry['place']>,
): LoadPlaceSuccessAction => ({
  place,
  placeKey,
  type: PlaceActionType.LoadPlaceSuccess,
});
